// Pagination and timing constants
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Page size for the `Chat.users` connection.
 *
 * The resolver hard-caps this at 50 (`Math.min(first, 50)` in userService's
 * chatUsers handler) and the connection exposes no `pageInfo`, so 50 is both
 * the most we can ask for and the most we can observe. Requesting less silently
 * drops participants: CRM-548 was a chat with 32 members where the single
 * distributor user sat at position 31 and never rendered.
 *
 * This value is part of the Apollo cache key `Chat:{id}.users(first:$first)`,
 * so every query and mutation that selects ChatUsersFragment must pass the same
 * number — including the `$first` defaults in the .gql documents — or the
 * add/remove mutations stop updating what GetChatData reads.
 */
export const CHAT_USERS_PAGE_SIZE = 50;
export const DEBOUNCE_TIME = 300;

// Re-export chat options for convenience
export * from './chatOptions';
